/**
 * @generated SignedSource<<3b7a9fd30ceb097e9f49237a6ed0ae06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InteriorsLandingPageModuleDisplayType = "primary" | "secondary" | "tertiary" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingRooms_roomsModule$data = {
  readonly secondaryRoomsModule: {
    readonly displayType: InteriorsLandingPageModuleDisplayType | null;
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly imageHeight: string | null;
      readonly imageUrl: string | null;
      readonly imageWidth: string | null;
      readonly linkUrl: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly tertiaryRoomsModule: {
    readonly displayType: InteriorsLandingPageModuleDisplayType | null;
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly imageHeight: string | null;
      readonly imageUrl: string | null;
      readonly imageWidth: string | null;
      readonly linkUrl: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "InteriorsLandingRooms_roomsModule";
};
export type InteriorsLandingRooms_roomsModule$key = {
  readonly " $data"?: InteriorsLandingRooms_roomsModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingRooms_roomsModule">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "InteriorsLandingModuleItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "linkUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageHeight",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageWidth",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingRooms_roomsModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "secondaryRoomsModule",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "tertiaryRoomsModule",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingPage",
  "abstractKey": null
};
})();

(node as any).hash = "e32462ab04d383d287351222ec27d7e4";

export default node;
